import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation SpaceRecordUnlock(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordUnlock(spaceRecordIds: $spaceRecordIds)
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceRecordUnlockMutation,
    readonly ents.core.dms.data.Record.Id[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceRecordUnlock',
                graphql.transformers.OUT.default(
                  graphql.transformers.OUT.list(
                    graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.core.dms.data.Record.Id.isId,
                    ),
                  ),
                  [],
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordUnlockMutation,
  readonly ents.core.dms.data.Record.Id[],
  graphql.schema.SpaceRecordUnlockMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
